import { Dayjs } from "dayjs"
import { IEnrolmentAutomatedCommunication } from "./enrolmentAutomatedCommunication.types"

export class EnrolmentAutomatedCommunication implements IEnrolmentAutomatedCommunication {
  constructor(
    public createdAt: Dayjs,
    public enrolmentId: number,
    public paragraphOne: string | null,
    public paragraphTwo: string | null,
    public commsSent?: string | null,
    public commsSentTo?: string | null,
  ) {}

  get isMpanInUse() {
    return this.commsSent === "Mpan In Use"
  }
}
